import { createApp } from "vue";
import { createPinia } from "pinia";

import { configStore, i18n, i18nPlugin } from "@tager/admin-services";

import "@/styles";
import { router } from "@/router";
import config from "@/config/config.json";
import App from "@/views/App.vue";
import { populateEnvironment } from "@/env";
import { initSentry } from "@/sentry";

populateEnvironment();

configStore.setConfig(config);

const pinia = createPinia();
const app = createApp(App);

initSentry(app);

app.use(router);
app.use(i18nPlugin);
app.use(pinia);

i18n.init({ debug: false }).then(() => {
  app.mount("#app");
});
